var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPrivate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-private"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.3335 10.2001C3.3335 13.2833 5.0281 14.6654 7.39309 14.6654C8.89526 14.6654 10.0126 14.1651 10.9064 13.2145C12.1479 11.8949 12.5576 9.88112 12.7935 9.09939C12.9859 8.474 13.3335 7.686 13.3335 7.26699C13.3335 6.99807 12.9797 6.76042 12.7438 6.76042C12.21 6.76042 12.0051 7.00433 11.6948 7.67975C11.3472 8.42396 10.9251 9.81233 10.5899 9.81233C10.3974 9.81233 10.3292 9.46211 10.3292 8.81171V2.77668C10.3292 2.44523 10.1305 2.14504 9.70842 2.14504C9.29253 2.14504 9.08769 2.44523 9.08769 2.77668V7.71727C8.88905 7.66099 8.65938 7.61096 8.41109 7.57969V1.95742C8.41109 1.62596 8.20625 1.33203 7.79036 1.33203C7.37446 1.33203 7.16962 1.62596 7.16962 1.95742V7.53591C6.93995 7.54842 6.71649 7.57343 6.49302 7.61096V2.43897C6.49302 2.10752 6.28198 1.80733 5.87229 1.80733C5.46261 1.80733 5.25156 2.10752 5.25156 2.43897V7.96117C5.00947 8.06124 4.7798 8.18006 4.57496 8.31139V4.38394C4.57496 4.05248 4.38253 3.75229 3.96664 3.75229C3.53834 3.75229 3.3335 4.05248 3.3335 4.38394V10.2001Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPrivate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-private.6fa91a9867378577326254cccf8a1bd8.svg";